module.exports = __webpack_public_path__ + "static/media/Ad-Server-Dashboard-2.2a9ad22d.jpg";